import isString from 'lodash/isString';

/**
 * Check if string doesn't contain any special characters or numbers.
 *
 * @param {String} string
 *
 * @returns {Boolean}
 */
export const isValidAlphabetString = (string) => {
    if (!string || !isString(string)) return false;

    let stringRegEx = new RegExp(
        /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
    );

    return stringRegEx.test(string);
};
